export const parseToNumber = (value: string | undefined): number =>
	value ? Number(value) : Number.NaN;

export const parseToFiniteNumber = (
	value: string | undefined,
): number | undefined => {
	const parsed = parseToNumber(value);
	return Number.isFinite(parsed) ? parsed : undefined;
};
